import EnterSubDomain from './EnterSubDomain'

export default EnterSubDomain